import { InitializerExecutor } from '@wajeez-web/core/types';
import { NavigationActions } from '@wajeez-web/stores/common';
import RolesAndPermisionsPage from './pages/RolesAndPermisionsPage';
import { SiAuth0 } from 'react-icons/si';
import { RiTeamFill } from 'react-icons/ri';
import WajeezTeamPage from './pages/WajeezTeamPage';
export const initializeRolesRoutes: InitializerExecutor = async (dispatch) => {
  dispatch(
    NavigationActions.updateRoutes([
      {
        name: 'Roles and Permissions',
        href: '/roles-permissions',
        per: ['19.0'],
        icon: SiAuth0,
        children: [],
      },
      {
        name: 'Wajeez Team',
        href: '/wajeez-team',
        per: ['18.28'],
        icon: RiTeamFill,
        children: [],
      },
    ])
  );
};

export const initializeRolesEndpoints: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateEndpoints([
      {
        type: 'container',
        endpoint: 'roles-permissions',
        crump: 'roles-permissions',
        per: ['19.0'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: RolesAndPermisionsPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'wajeez-team',
        crump: 'wajeez-team',
        per: ['18.28'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: WajeezTeamPage,
            per: [],
          },
        ],
      },
    ])
  );
};
